import { useEffect, useState } from 'react';
import { useButtonsStore } from '.';

function useUndoLogo () {
    const buttonsStore = useButtonsStore();

    const [undoEnable, setUndoEnable] = useState(false);
    const [redoEnable, setRedoEnable] = useState(false);

    useEffect(() => {
        setUndoEnable(buttonsStore.undoEnable);
    }, [buttonsStore.observed.undoEnable]);

    useEffect(() => {
        setRedoEnable(buttonsStore.redoEnable);
    }, [buttonsStore.observed.redoEnable]);

    function pushActiveStates () {
        // both state and ui
        buttonsStore.pushLogoEditorActiveStates();
    }

    function undoLogo () {
        buttonsStore.undoLogoState();
    }

    function redoLogo () {
        buttonsStore.redoLogoState();
    }

    return {
        pushActiveStates,
        undoLogo,
        redoLogo,
        undoEnable,
        redoEnable,
        setLogoImageURI: (url) => buttonsStore.setLogoImageURI(url),
        setIsImageBrowsed: (v) => buttonsStore.setIsImageBrowsed(v),
        getImageDataURI: async (url) => {
            return await buttonsStore.getImageDataURI(url);
        },
    };
}

export default useUndoLogo;
